module.exports = __webpack_public_path__ + "img/loghi_0008_avanzi.c6419ae5.png";